module.exports = __webpack_public_path__ + "static/coffee_bean_and_tea_leaf.2e34d892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/coffee_bean_and_tea_leaf.png
// module id = 2169
// module chunks = 61762850755587